<template>
    <div>
        <h4>Redireccionando...</h4>
    </div>
</template>

<script>
export default {
  mounted() {
    const query = this.$route.query;
    if (query && query.redirect) {
      window.localStorage.setItem('auth:redirect', query.redirect);
    } else {
      window.localStorage.removeItem('auth:redirect');
    }

    setTimeout(() => {
      this.$store.dispatch('auth/login');
    }, 0);
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/auth/login.vue